import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Icon, Message } from 'semantic-ui-react';
import moment from 'moment';
import classNames from 'classnames';
import _ from 'lodash';
import qs from 'qs';
import { reset } from 'redux-form';

import { Filter, Main } from 'Containers/';
import { CLOSE_PRODUCTION_FORM_NAME } from 'Common/FormEnum';
import { LoadingBase } from 'Components/';
import {
  DATE_FORMAT_DAY_MONTH_NUMBER,
  NOTIFICATION_DIALOG_MESSAGES,
} from 'Common/Constants';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import {
  NUMBER_OF_DAYS_TO_DISPLAY,
  Modals,
} from 'Pages/manageproduction/helpers/Constants';
import {
  ProductionRecordFieldEnum as ProdRecordFields,
  EditProductionRecordFieldEnum as EditProductionRecordFields,
} from 'Common/FieldEnum';
import * as SiteActions from 'State/sites/actions';
import * as CommonStateSelectors from 'State/selectors';
import * as CommonActions from 'Pages/managemenu/state/common/actions';
import { ProductionStatusEnum } from 'Common/Constants/Enumeration/ProductionStatusEnum';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { convertStatusToText } from 'Pages/manageproduction/helpers/productionRecord';
import * as RecipeSearchSelectors from 'Common/Components/RecipeSearch/state/selectors';
import 'Styles/pages/manageproduction/editProduction.less';

import * as EditProductionSelectors from '../../state/editproduction/selectors';
import * as EditProductionActions from '../../state/editproduction/actions';
import { EditProductionForm } from './components/EditProductionForm';
import { ProductionRecipeSearch } from './components/ProductionRecipeSearch';
import { RecipeLeftoversPanel } from './components/RecipeLeftoversPanel';
import { PrintProductionModal } from './components/PrintProductionModal';

class EditProduction extends Component {
  static path = '/manageproduction/edit/:cycleMenuId/:startDate/:endDate';
  formRef = React.createRef();

  MODALS = {
    RECIPE_SEARCH: 0,
    LEFTOVERS: 1,
  };

  state = {
    [this.MODALS.RECIPE_SEARCH]: false,
    [this.MODALS.ADD_LEFTOVERS]: false,
    showCloseForm: false,
    recipeToAdd: null,
  };

  async componentDidMount() {
    const {
      match,
      getProdRecords,
      location,
      getSites,
      getRecipeSearchFilters,
    } = this.props;

    const { cycleMenuId, startDate, endDate } = match.params;
    const queryParamObj = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    await getProdRecords({
      [EditProductionRecordFields.SiteIds]:
        queryParamObj[EditProductionRecordFields.SiteIds],
      [EditProductionRecordFields.CycleMenuId]: cycleMenuId,
      [EditProductionRecordFields.StartDate]: startDate,
      [EditProductionRecordFields.EndDate]: endDate,
      [ProdRecordFields.ServingDT]: queryParamObj[ProdRecordFields.ServingDT],
    });
    getSites();
    getRecipeSearchFilters();
    this.getRecipeLeftovers();
    window.addEventListener('beforeunload', this.onWindowClose);
  }

  componentDidUpdate(prevProps) {
    const {
      saveSuccessful: prevSaveSuccessful,
      closeSuccessful: prevCloseSuccesful,
      startOverSuccessful: prevStartOverSuccessful,
    } = prevProps;
    const {
      clearError,
      saveSuccessful,
      setSaveSuccessful,
      closeSuccessful,
      setCloseSuccessful,
      startOverSuccessful,
      setStartOverSuccessful,
    } = this.props;

    if (errorToast(this.props, prevProps, 'error')) {
      clearError();
    }

    if (saveSuccessful && prevSaveSuccessful !== saveSuccessful) {
      createToast(toastType.success, 'Success', 'Saved Successfully.', true);

      setSaveSuccessful(false);
    }

    if (closeSuccessful && prevCloseSuccesful !== closeSuccessful) {
      createToast(toastType.success, 'Success', 'Closed Successfully.', true);
      setCloseSuccessful(false);
    }

    if (
      startOverSuccessful &&
      prevStartOverSuccessful !== startOverSuccessful
    ) {
      createToast(
        toastType.success,
        'Success',
        'Started Over Successfully.',
        true
      );
      setStartOverSuccessful(false);
    }
  }

  componentWillUnmount() {
    const { clearState } = this.props;

    clearState();
    window.removeEventListener('beforeunload', this.onWindowClose);
  }

  get mainProps() {
    return {
      toolbox: {
        shown: true,
        backButtonProps: {
          path: '/manageproduction',
          shown: true,
        },
      },
      shouldNotUsePageWidth: true,
    };
  }

  getIsDirty() {
    const { initialProdRecords } = this.props;

    if (this.formRef.current) {
      const prodRecords = this.formRef.current.prodRecords;

      return !_.isEqual(initialProdRecords, prodRecords);
    }
    return false;
  }

  getToolboxProps = () => {
    const { isReadOnly, isOpen } = this;
    const {
      setNotificationDialog,
      viewProdRecordIndex,
      prodRecord,
      fetchingStartOver,
      leftoversList,
      fetchingCloseProd,
      changeModalVisiblity,
      history,
    } = this.props;

    return {
      shown: true,
      backButtonProps: {
        shown: true,
        onClick: () => {
          if (this.getIsDirty()) {
            setNotificationDialog({
              ...NOTIFICATION_DIALOG_MESSAGES.DIRTY_PROMPT,
              functionsToRunOnOk: [
                () => {
                  history.push('/manageproduction');
                },
              ],
            });
          } else {
            history.push('/manageproduction');
          }
        },
      },
      rightButtons: [
        {
          onClick: () => changeModalVisiblity(Modals.Print, true),
          content: 'Print',
        },
        ...(!isReadOnly && [
          {
            onClick: () => {
              if (!leftoversList || leftoversList.length === 0) {
                createToast(
                  toastType.warning,
                  'No leftovers available to add.',
                  '',
                  true
                );
                return;
              }

              this.openModal(this.MODALS.ADD_LEFTOVERS);
            },
            content: 'Add Leftovers',
          },
          {
            onClick: () => this.openModal(this.MODALS.RECIPE_SEARCH),
            content: 'Add Recipes',
          },
          {
            onClick: () => {
              changeModalVisiblity(Modals.ProductionPlan, true);
              changeModalVisiblity(Modals.Close, true);
            },
            content: 'Verify and Close',
            disabled: fetchingCloseProd,
            loading: fetchingCloseProd,
          },
        ]),
        {
          onClick: () => {
            const functionsToRunOnOk = [
              () => this.startOverProdRecord(prodRecord, viewProdRecordIndex),
            ];
            setNotificationDialog({
              ...NOTIFICATION_DIALOG_MESSAGES.PRODUCTION_RECORD_START_OVER,
              functionsToRunOnOk,
            });
          },
          content: 'Start Over',
          disabled: isReadOnly || !isOpen || fetchingStartOver,
          loading: fetchingStartOver,
        },
      ],
      isReadOnly,
    };
  };

  get site() {
    const { sitesMap, prodRecord } = this.props;

    return (
      _.get(sitesMap, [prodRecord[ProdRecordFields.SiteId], 'Description']) ||
      prodRecord[ProdRecordFields.SiteId]
    );
  }

  get filterTitle() {
    const { prodRecord } = this.props;
    let title = 'Edit Production Records';

    if (prodRecord) {
      const site = this.site;
      const status = prodRecord[ProdRecordFields.Status];

      if (site) {
        title = `${title} - ${site}`;
      }

      title = `${title} - ${prodRecord[ProdRecordFields.CycleMenuDescription]}`;

      const statusText = _.toUpper(convertStatusToText(status));

      if (statusText) {
        title = `${title} - ${statusText}`;
      }
    }

    return title;
  }

  openModal = (modal) => this.setState({ [modal]: true });
  closeModal = (modal) =>
    this.setState({ [modal]: false, showCloseForm: false });
  getModalProps = (modal) => {
    const { [modal]: showModal } = this.state;
    return {
      open: showModal,
      onClose: () => this.closeModal(modal),
    };
  };

  onWeekButtonClick = (index) => {
    const { viewProdRecordAndLoad } = this.props;

    viewProdRecordAndLoad(index);
  };

  getRecipeLeftovers() {
    const { match, getRecipeLeftovers } = this.props;
    const { startDate, endDate } = match.params;

    getRecipeLeftovers(startDate, endDate);
  }

  renderWeekButtons() {
    const {
      viewProdRecordIndex,
      prodRecordDates,
      changeStartFromIndex,
      startFromIndex,
      prodRecords,
      changeModalVisiblity,
    } = this.props;

    const showChevron = prodRecords.length > NUMBER_OF_DAYS_TO_DISPLAY;

    return (
      <div className="ep-week-buttons">
        {showChevron && (
          <Icon
            className="caret left"
            link
            size="large"
            onClick={() => changeStartFromIndex(startFromIndex - 1)}
          />
        )}
        {prodRecordDates.map((date) => {
          const prodRecord = prodRecords[date.index];
          const status = _.get(prodRecord, ProdRecordFields.Status);
          const statusText = convertStatusToText(status);
          const active = date.index === viewProdRecordIndex;
          const className = classNames(
            'ep-week-button',
            {
              active,
            },
            statusText
          );

          return (
            <div
              className={className}
              onClick={() => this.onWeekButtonClick(date.index)}
              key={date.index}
            >
              {moment(date.value).format(DATE_FORMAT_DAY_MONTH_NUMBER)}
              <div className="edit-production-detail-btn-container">
                <Button
                  onClick={() =>
                    changeModalVisiblity(Modals.ProductionPlan, true)
                  }
                  fluid
                  className="mnm-button-blue"
                >
                  Production Details
                </Button>
              </div>
            </div>
          );
        })}
        {showChevron && (
          <Icon
            className="caret right"
            link
            size="large"
            onClick={() => changeStartFromIndex(startFromIndex + 1)}
          />
        )}
      </div>
    );
  }

  onAddRecipe = (index) => {
    const { recipes } = this.props;
    const recipe = recipes[index];

    if (recipe) {
      this.setState({ recipeToAdd: { ...recipe } });
    }
  };

  onAddLeftoverRecipe = (recipe) => {
    if (recipe) {
      this.setState({ recipeToAdd: { ...recipe } });
    }
  };

  clearRecipeToAdd = () => {
    this.setState({ recipeToAdd: null });
  };

  renderProductionGrid() {
    const { isReadOnly } = this;
    const {
      prodRecords,
      viewProdRecordIndex,
      expandedRecipesByProdRecord,
    } = this.props;
    const {
      [this.MODALS.RECIPE_SEARCH]: showRecipeSearch,
      [this.MODALS.ADD_LEFTOVERS]: showAddLeftovers,
      recipeToAdd,
    } = this.state;

    if (prodRecords.length > 0) {
      return (
        <Fragment>
          {showRecipeSearch && (
            <ProductionRecipeSearch
              onSearchCloseClick={() =>
                this.closeModal(this.MODALS.RECIPE_SEARCH)
              }
              onAddRecipe={this.onAddRecipe}
            />
          )}
          {showAddLeftovers && (
            <RecipeLeftoversPanel
              onSearchCloseClick={() =>
                this.closeModal(this.MODALS.ADD_LEFTOVERS)
              }
              onAddRecipe={this.onAddLeftoverRecipe}
            />
          )}
          {this.renderWeekButtons()}
          <EditProductionForm
            isReadOnly={isReadOnly}
            prodRecords={prodRecords}
            viewProdRecordIndex={viewProdRecordIndex}
            recipeToAdd={recipeToAdd}
            expandedRecipesByCategory={
              expandedRecipesByProdRecord[viewProdRecordIndex] || {}
            }
            toolboxProps={this.getToolboxProps()}
            saveProdRecords={this.saveProdRecords}
            closeProdRecord={this.closeProdRecord}
            clearRecipeToAdd={this.clearRecipeToAdd}
            forwardRef={this.formRef}
          />
        </Fragment>
      );
    }

    return (
      <Main {...this.mainProps}>
        <Message color="blue">
          There are no production records to display.
        </Message>
      </Main>
    );
  }

  saveProdRecords = (formValues) => {
    const { saveProdRecords, match } = this.props;
    const { startDate, endDate } = match.params;

    saveProdRecords({ data: formValues, startDate, endDate });
  };

  get isReadOnly() {
    const { isReadOnly, prodRecord } = this.props;
    const isClosed = _.get(prodRecord, ProdRecordFields.IsClosed, false);
    return isReadOnly || isClosed;
  }

  get isOpen() {
    const { prodRecord } = this.props;
    return (
      _.get(prodRecord, ProdRecordFields.Status) === ProductionStatusEnum.Open
    );
  }

  closeProdRecord = async (prodRecord, index) => {
    const { closeProdRecord, reset } = this.props;
    await closeProdRecord(prodRecord, index);
    reset(CLOSE_PRODUCTION_FORM_NAME);
    this.getRecipeLeftovers();
  };

  startOverProdRecord = async (prodRecord, index) => {
    const id = prodRecord[ProdRecordFields.Id];
    const { startOverProdRecord } = this.props;
    await startOverProdRecord(id, index);
    this.getRecipeLeftovers();
  };

  onWindowClose = (e) => {
    const isDirty = this.getIsDirty();

    if (isDirty) {
      e.preventDefault();
      e.returnValue = isDirty;
    }
  };

  render() {
    const {
      fetching,
      prodRecord,
      showPrintModal,
      changeModalVisiblity,
    } = this.props;

    if (fetching) {
      return <LoadingBase />;
    }

    return (
      <Fragment>
        <div className="ep-container">
          <Filter title={this.filterTitle} columnWidths={{ title: 10 }} />
          {this.renderProductionGrid()}
          {showPrintModal && prodRecord && (
            <PrintProductionModal
              modalProps={{
                onClose: () => changeModalVisiblity(Modals.Print, false),
                open: showPrintModal,
              }}
              prodRecord={prodRecord}
              site={this.site}
            />
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    prodRecords: EditProductionSelectors.getProdRecords(state),
    startFromIndex: EditProductionSelectors.getStartFromIndex(state),
    prodRecord: EditProductionSelectors.getProdRecord(state),
    prodRecordDates: EditProductionSelectors.getProdRecordDatesToShow(state),
    fetching:
      EditProductionSelectors.getFetching(state) ||
      CommonStateSelectors.getSitesLoading(state),
    viewProdRecordIndex: EditProductionSelectors.getViewProdRecordIndex(state),
    error: EditProductionSelectors.getError(state),
    saveSuccessful: EditProductionSelectors.getSaveSuccessful(state),
    sitesMap: CommonStateSelectors.getSitesMap(state),
    fetchingCloseProd: EditProductionSelectors.getFetchingCloseProd(state),
    fetchingStartOver: EditProductionSelectors.getFetchingStartOver(state),
    closeSuccessful: EditProductionSelectors.getCloseSuccessful(state),
    leftoversList: EditProductionSelectors.getAvailableLeftovers(state),
    startOverSuccessful: EditProductionSelectors.getStartOverSuccessful(state),
    recipes: RecipeSearchSelectors.getRecipes(state),
    expandedRecipesByProdRecord: EditProductionSelectors.getExpandedRecipesByProdRecord(
      state
    ),
    showPrintModal: EditProductionSelectors.getShowPrintModal(state),
    initialProdRecords: EditProductionSelectors.getInitialProdRecords(state),
  };
};

const mapDispatchToProps = {
  viewProdRecordAndLoad: EditProductionActions.viewProdRecordAndLoad,
  changeStartFromIndex: EditProductionActions.changeStartFromIndex,
  getProdRecords: EditProductionActions.getProdRecords,
  clearError: EditProductionActions.clearError,
  getSites: SiteActions.getSites,
  saveProdRecords: EditProductionActions.saveProdRecords,
  reset,
  setSaveSuccessful: EditProductionActions.setSaveSuccessful,
  setCloseSuccessful: EditProductionActions.setCloseSuccessful,
  clearState: EditProductionActions.clearState,
  closeProdRecord: EditProductionActions.closeProdRecord,
  getRecipeSearchFilters: CommonActions.getSearchFilters,
  getRecipeLeftovers: EditProductionActions.getRecipeLeftovers,
  setNotificationDialog,
  startOverProdRecord: EditProductionActions.startOverProdRecord,
  setStartOverSuccessful: EditProductionActions.setStartOverSuccessful,
  changeModalVisiblity: EditProductionActions.changeModalVisiblity,
};

EditProduction = connect(mapStateToProps, mapDispatchToProps)(EditProduction);

export { EditProduction };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/EditProduction.js